import { Pipe, PipeTransform } from '@angular/core';
import { getActivityUserState } from './activity.functions';

@Pipe({
  name: 'activityUserState'
})
export class ActivityUserStatePipe implements PipeTransform {
    transform(activity?: any): string {
        return getActivityUserState(activity);
    }
};